export default "__VITE_ASSET__D451YbLa__"